module.exports = __webpack_public_path__ + "static/assets/92a1e597db2069a5882e9e19dc9a7e7d.svg";